module.exports = __webpack_public_path__ + "img/chat-icon.bc68468f.svg";